import { Controller } from "@hotwired/stimulus"

// This controller is used to update the leads list page size and then reload the page.
export default class extends Controller {
  update(event) {
    fetch("/leads/settings", {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
      body: JSON.stringify({
        user: { leads_page_size: event.target.value },
      }),
      credentials: "same-origin",
    }).then(() => location.reload())
  }
}
